import { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { getUserData, signInAdmin, signOutAdmin } from "../helpers/http_auth_requests";
import globalToast from "../components/common/globalToast";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [id, setId] = useState(null);

    async function spreadUserData({ welcome } = {}) {
        try {
            const data = await getUserData();

            if (data && data.user_data) {
                setUser(data.user_data);
                setId(data.user_data.id);
                if (welcome) {
                    globalToast.success(`Seja bem-vindo(a), ${data.user_data['complete_name']}!`);
                }
                return true;
            }
        } catch (error) {
            console.log("Erro ao obter dados do usuário:", error);
        };
        return false;
    };

    async function signIn(user, password) {
        try {
            const data = await signInAdmin(user, password);

            if (data && data.success) {
                await spreadUserData({ welcome: true });
            } else if (data) {
                globalToast.error(data.message)
            }

        } catch (error) {
            globalToast.error("Houve um erro ao tentar acessar a conta! Tente novamente mais tarde.");
            console.log("Erro no processo de login:", error);
        }
    };

    async function signOut() {
        await signOutAdmin();
        globalToast.success("Até a próxima! 😀")
        setUser(null);
        setId(null);
        localStorage.removeItem('user_token');
    };

    useEffect(() => {
        localStorage.removeItem('user_token');
        spreadUserData();
    }, []);

    return (
        <AuthContext.Provider
            value={{
                user,
                id,
                token: null,
                setToken: () => {},
                signIn,
                signOut,
            }} >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
};
